module.exports = __webpack_public_path__ + "img/dummy-book.9e0ea17.webp";